import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import './home.scss';
import '../layout/main.scss';
import chart1 from '../../images/chart1.png'
import chart2 from '../../images/chart2.png'
import chart3 from '../../images/chart3.png'


function Home() {
    // @ts-ignore
    return (
        <div className="App">
            <div className="home">
                <Container>
                    <div className="mn-blocks home-spotlight">
                        <h4>Welcome</h4>
                        <Row>
                            <Col className="col-sm-12 col-md-4">
                                <div className="buttons">
                                    <a href="/Request"><button>Request new certificate</button></a>
                                    <a href="/JudgeSpace"><button>Access judge space</button></a>
                                    <a href="/"><button>Elect judges</button></a>
                                </div>
                            </Col>
                            <Col className="col-sm-12 col-md-8">
                                <div className="cards transactions">
                                    <h5>Recent certificates</h5>
                                    <p>NFT #001 Ethereum / ID 1 / Contract 0xB96B17DA334eFB6c70533CF322E75F06FC576E01</p>
                                    <p>NFT #002 Ethereum / ID 2 / Contract 0x406eb9d6d9e204777ea2d291dea2d76070ba851di</p>
                                    <p>NFT #003 Ethereum / ID 3 / Contract 0x458EA34b44603f8B899c6f388507aD43D6dd0036h</p>
                                    <a href="/Browse" >Browse certificates</a>
                                    <div className="clearfix"/>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className="mn-blocks stats">
                        <Row>
                            <Col className="col-sm-12 col-md-4">
                                <div className="cards">
                                    <h5>Netspace</h5>
                                    Super chart
                                    <img src={chart1} />
                                </div>
                            </Col>
                            <Col className="col-sm-12 col-md-4">
                                <div className="cards">
                                    <h5>Judge space</h5>
                                    Chart chart chart
                                    <img src={chart2} />
                                </div>
                            </Col>
                            <Col className="col-sm-12 col-md-4">
                                <div className="cards">
                                    <h5>Certifications</h5>
                                    Amazing chart!
                                    <img src={chart3} />
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className="mn-blocks home-spotlight">
                        <h4>Latest news</h4>
                        <Row>
                            <Col className="col-sm-12 col-md-6">
                                <div className="cards transactions">
                                    <h5>Whatever happened recently</h5>
                                    <p>Some kind of lorem ipsum text right here... View more</p>
                                    <p>Wow can't believe it's finally happening... View more</p>
                                </div>
                            </Col>
                            <Col className="col-sm-12 col-md-6">
                                <div className="cards transactions">
                                    <h5>Twitter plugin or smth</h5>
                                    <p>Our Twitter account is so lit, check this!</p>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </div>
        </div>
    );
}

export default Home;
